import React, { useState, useEffect } from "react";
import { DashboardSidebarIndex } from "@Src/features/Dashboard/Sidebar/Index";
import { DashHeaderIndex } from "@Src/features/Dashboard/Dash-header/Dash-header";
import { Link, useNavigate } from "react-router-dom";
import SvgIcon from "@Components/icons/SvgIcon";
import { AppRouteURL } from "@Constants/app-route-url.constant";
import { getSubscriptionHistory } from "../Subscription/services/Subscription.service";
import { APIResponse, APIStatus } from "@Src/services/baseInterfaces";
import { Paginator } from 'primereact/paginator';
import { Skeleton } from 'primereact/skeleton';
import moment from "moment";
import "./SubscriptionHistory.scss";
import { useAppSelector } from "@Src/app/hooks";

export const SubscriptionHistoryIndex = () => {
    const navigate = useNavigate();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [historyData, setHistoryData] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    // Pagination states
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const instituteId = useAppSelector(state => state.login.InstituteId);

    useEffect(() => {
        if (instituteId) {
            navigate('/');
        }
    }, [instituteId]);
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    useEffect(() => {
        fetchHistory(1, rows);
    }, []);

    const fetchHistory = async (page: number, limit: number) => {
        setLoading(true);
        try {
            const response: APIResponse = await getSubscriptionHistory({ page, limit });
            if (response.ResponseType === APIStatus.SUCCESS && response.data?.[0]) {
                const result = response.data[0];
                setHistoryData(result.data || []);
                setTotalRecords(result.total_count || 0);
            }
        } catch (error) {
            console.error("Error fetching subscription history:", error);
        } finally {
            setLoading(false);
        }
    };

    const onPageChange = (event: any) => {
        setFirst(event.first);
        setRows(event.rows);
        const page = event.page + 1;
        fetchHistory(page, event.rows);
    };

    const formatDate = (dateString: string | null) => {
        if (!dateString) return "N/A";
        return moment(dateString).format("DD-MM-YYYY");
    };

    const renderTableSkeleton = () => {
        return (
            <div className="tw-space-y-4">
                {[...Array(5)].map((_, i) => (
                    <div key={i} className="tw-flex tw-gap-4">
                        <Skeleton height="3rem" className="tw-flex-1" />
                        <Skeleton height="3rem" className="tw-flex-1" />
                        <Skeleton height="3rem" className="tw-flex-1" />
                        <Skeleton height="3rem" className="tw-flex-1" />
                    </div>
                ))}
            </div>
        );
    };

    return (
        <div className="subscription-history-feature">
            <DashHeaderIndex toggleSidebar={toggleSidebar} />
            <div className="dashboard-container">
                <div className={`dashboard-sidebar ${isSidebarOpen ? 'show' : ''}`}>
                    <DashboardSidebarIndex closeSidebar={() => setIsSidebarOpen(false)} />
                </div>
                <div className="dashboard-content-page" onClick={() => isSidebarOpen && setIsSidebarOpen(false)}>
                    <div className="subscription-page-container">
                        <div className="tw-mb-4">
                            <Link
                                to={AppRouteURL.SUBSCRIPTION}
                                className="tw-flex tw-items-center tw-gap-2 tw-text-gray-600 hover:tw-text-[#986efa] tw-transition-colors tw-font-medium"
                            >
                                <SvgIcon name="rightArrow" size={25} style={{ transform: 'rotate(180deg)' }} />
                            </Link>
                            {/* <div className="subscription-header">
                                <h1 className="subscription-heading">Subscription History</h1>
                                <p className="subscription-subheading">View your subscription details and history</p>
                            </div> */}
                        </div>

                        <div className="subscription-history-card">
                            <h3 className="tw-text-xl tw-font-semibold tw-mb-4 tw-text-gray-800">Subscription History</h3>

                            <div className="table-responsive">
                                {loading ? renderTableSkeleton() : (
                                    <table className="subscription-table">
                                        <thead>
                                            <tr>
                                                <th>Plan</th>
                                                <th>Mocktests</th>
                                                <th>Start Date</th>
                                                <th>End Date</th>
                                                <th>Price</th>
                                                {/* <th>Coupon</th> */}
                                                <th>Transaction Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {historyData.length > 0 ? historyData.map((item: any) => (
                                                <tr key={item.SubscriptionId}>
                                                    <td>
                                                        <span className="plan-name-cell">{item.PlanName}</span>
                                                    </td>
                                                    <td>
                                                        <div>Total: {item.NumberOfMocktests}</div>
                                                        <div className="tw-text-xs tw-text-gray-400">Balance: {item.BalanceNumberOfMocktests}</div>
                                                    </td>
                                                    <td>{formatDate(item.StartDate)}</td>
                                                    <td>{formatDate(item.EndDate)}</td>
                                                    <td className="price-cell">₹{item.FinalPrice}</td>
                                                    {/* <td>
                                                        {item.CouponCode ? (
                                                            <span className="tw-bg-green-100 tw-text-green-700 tw-px-2 tw-py-1 tw-rounded tw-text-xs tw-font-medium">
                                                                {item.CouponCode}
                                                            </span>
                                                        ) : "None"}
                                                    </td> */}
                                                    <td>{item.TransactionDate ? formatDate(item.TransactionDate) : "N/A"}</td>
                                                </tr>
                                            )) : (
                                                <tr>
                                                    <td colSpan={7} className="tw-text-center tw-py-8">No subscription history found.</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                )}
                            </div>

                            {!loading && totalRecords > 0 && (
                                <Paginator
                                    first={first}
                                    rows={rows}
                                    totalRecords={totalRecords}
                                    rowsPerPageOptions={[10, 20, 30]}
                                    onPageChange={onPageChange}
                                    className="custom-paginator"
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {isSidebarOpen && (
                <div
                    className="sidebar-backdrop"
                    onClick={() => setIsSidebarOpen(false)}
                />
            )}
        </div>
    );
};